/*
 *   File : kyc-status.js
 *   Author URI : https://evoqins.com
 *   Description : Fetch data from digi locker.
 *   Integrations : null
 *   Version : v1.1
 */


import { toast } from 'react-toastify';
import APIService from "../../../Services/api-service";
import { CustomLoader } from '../../../Components/Other';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';



export default function DigioCallback() {
    const navigate = useNavigate();

    useEffect(() => {
        const query_params = new URLSearchParams(window.location.search);

        const verification_type = query_params.get("verification-type")
        console.log('verification_type', verification_type);

        const type = query_params.get("type");
        const digio_doc_id = query_params.get("digio_doc_id");
        const status = query_params.get("status");
        const id = query_params.get("id");

        const customer_id = verification_type === 'esign'
            ? localStorage.getItem("customer_id")
            : id;

        let callback_api_url = '';
        let is_second_url = false;
        switch (verification_type) {
            case 'address': callback_api_url = 'kyc/digilocker/callback';
                break;
            case 'ipv': callback_api_url = 'kyc/ipv/callback';
                break;
            case 'esign': callback_api_url = type == 'HUF' ? 'kyc/esign/callback-agreement' : 'kyc/esign/callback';
                is_second_url = type == 'HUF' ? false : true;
                break;

        }

        // _digioCallback(callback_api_url, is_second_url, id);
        _digioCallback(callback_api_url, is_second_url, customer_id,
            verification_type === 'esign' ? digio_doc_id : null,
            verification_type === 'esign' ? status : null
        );
    }, []);

    function _digioCallback(url, url_v, id, digio_doc_id, status) {

        console.log('customer_id', id);


        // let payload = JSON.stringify({
        //     customer_id: id
        // });
        let payload = JSON.stringify({
            customer_id: id,
            ...(digio_doc_id && { digio_doc_id }),
            ...(status && { status }),
        });


        APIService(true, url, payload, url_v).then((response) => {
            if (response.status_code === 200) {
                navigate("/create-account", {
                    state: {
                        user_id: id
                    }
                })
            } else {
                toast.dismiss();
                toast.error(response.message);
                setTimeout(() => {
                    navigate("/create-account", {
                        state: {
                            user_id: id
                        }
                    })
                }, 3000)
            }
        })
    }

    return (
        <div className="w-100 h-100vh d-flex justify-content-center align-items-center">
            <CustomLoader />
        </div>
    )

}